module.exports = {
  featuresList: {
    googleFit: 'Google Fit',
  },
};
